import React from 'react'
import { NavLink } from 'react-router-dom'

export const MenuItem = (
    {to,children,icon=""}
) => {
  return (
    <div className="menu-item menu-accordion">
        <NavLink 
        to={to}
        className="menu-link">
            <div className="menu-icon">
                {icon!=="" ? <i className={icon}></i> : <div className="bullet bullet-dot"></div>}
            </div>
            <div className="menu-title">{children}</div>
        </NavLink>
    </div>
  )
}
